import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const DepreciacionAnualFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-modelo', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label
        text='% DEPREC. ANUAL'
        htmlFor='input-depreciacionAnual'
        md={4}
        alignRightAt='md'
      />
      <Col md={4}>
        <Field name='depreciacionAnual'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              min={0}
              max={100}
              id='input-depreciacionAnual'
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DepreciacionAnualFormGroup)
